module.exports = __webpack_public_path__ + "img/reminders-1.56623cd1.gif";